var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-divider-black-primary';
                    var viewUrl = 'gfx/sprite.svg#view-icon-divider-black-primary';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 2 2',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };